module.exports = __webpack_public_path__ + "img/ef6d6c0f4c1c7b53d27db4ae128927da.c66968d4.jpg";